// 三国志 — client character data (with portraits). Generated by create-mod.
import { CHARACTERS_DATA, getCharacterById, getStartingMoney } from './characters-data';
import dongZhuo from './portraits/dong-zhuo.png';
import caoCao from './portraits/cao-cao.png';
import zhangFei from './portraits/zhang-fei.png';
import guanYu from './portraits/guan-yu.png';
import liuBei from './portraits/liu-bei.png';
import luBu from './portraits/lu-bu.png';
import yuanShao from './portraits/yuan-shao.png';
import liRu from './portraits/li-ru.png';

const PORTRAIT_MAP = {
  'dong-zhuo': dongZhuo,
  'cao-cao': caoCao,
  'zhang-fei': zhangFei,
  'guan-yu': guanYu,
  'liu-bei': liuBei,
  'lu-bu': luBu,
  'yuan-shao': yuanShao,
  'li-ru': liRu,
};

export const CHARACTERS = CHARACTERS_DATA.map(char => ({
  ...char,
  portrait: PORTRAIT_MAP[char.id] || null,
}));

export { getCharacterById, getStartingMoney };
